{
  "slug": "what-is-iq",
  "title": "Qu'est-ce que le QI?",
  "description": "Apprenez ce que signifie le QI, ce qu'un test de QI mesure et les limites importantes des scores du quotient d'intelligence.",
  "summary": "Le QI, abréviation de quotient d’intelligence, est un score normalisé conçu pour décrire les performances sur certaines tâches cognitives par rapport aux personnes d’un âge similaire.",
  "sections": [
    {
      "heading": "Ce qu'un score de QI représente",
      "paragraphs": [
        "Les tests de QI modernes combinent les résultats de tâches soigneusement conçues et les comparent à un groupe de référence représentatif. 100, donc un résultat décrit une performance relative plutôt qu'une quantité absolue d'intelligence.",
        "Les conditions de test, la santé, la langue, la motivation, la familiarité avec les formats de test et l’erreur normale de mesure peuvent tous avoir une incidence sur le résultat."
      ]
    },
    {
      "heading": "Ce que les tests de QI évaluent généralement",
      "paragraphs": [
        "Les batteries professionnelles échantillonnent plusieurs capacités cognitives au lieu de s'appuyer sur un type de puzzle."
      ],
      "bullets": [
        "Compréhension verbale et connaissances acquises",
        "Raisonnement visuel-spatial et fluide",
        "Mémoire de travail et attention",
        "Vitesse de traitement"
      ]
    },
    {
      "heading": "Ce que le QI ne mesure pas",
      "paragraphs": [
        "Le QI ne permet pas de mesurer la créativité, le jugement pratique, la curiosité, les compétences émotionnelles, la motivation, la sagesse ou les connaissances spécialisées, et ne peut pas déterminer la valeur ou l’avenir d’une personne.",
        "Une évaluation supervisée par un professionnel qualifié est plus appropriée pour les décisions cliniques, éducatives ou juridiques, mais un résultat de type QI en ligne devrait rester indicatif."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Que signifie IQ?",
      "answer": "Le QI est l’acronyme de quotient d’intelligence, un score standardisé comparant les performances cognitives sélectionnées avec un groupe de référence basé sur l’âge."
    },
    {
      "question": "Un test de QI en ligne est-il un diagnostic?",
      "answer": "Les résultats en ligne sont des estimations et ne doivent pas remplacer une évaluation par un professionnel qualifié."
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "what-is-the-average-iq"]
}
